import { httpClient } from "@utils";
import { CapacitorVersion } from "@api-types/capacitor/CapacitorVersion";
import { DateTime } from "luxon";

export default class CapacitorUpdaterApiService {
	public static get s3BucketUpdatePath(): string {
		return `${WEBPACK_CDN_ROOT_URL}/${WEBPACK_CDN_CAPACITOR_PATH}`;
	}

	static async getCurrentMobileVersion(): Promise<CapacitorVersion> {
		const url = `${this.s3BucketUpdatePath}/version.json?version=${DateTime.now().toMillis()}`;
		return httpClient.get(
			url,
			{
				"Content-Type": "application/json",
			},
			{
				cache: "no-store",
			}
		);
	}
}
